import React from 'react';
import { TABS } from '../tabs';

interface SidebarProps {
  activeTab: string;
  setActiveTab: (tab: any) => void;
  storageUsedStr?: string;
  storagePercent?: number;
  planName?: string;
  onUpgradeClick?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  activeTab,
  setActiveTab,
  storageUsedStr = '0 B / 2 GB',
  storagePercent = 0,
  planName = 'Free',
  onUpgradeClick,
}) => {
  const NavItem = ({ id, label, icon }: { id: string; label: string; icon: string }) => (
    <div
      className={`nav-item ${activeTab === id ? 'active' : ''}`}
      onClick={() => setActiveTab(id)}
      style={{ padding: '0.6rem 1.5rem', marginBottom: '0.2rem', borderRadius: '0 24px 24px 0', marginRight: '1rem' }}
    >
      <span style={{ fontSize: '1.2rem', width: '24px', display: 'inline-block', textAlign: 'center' }}>{icon}</span>
      <span style={{ fontSize: '0.9rem' }}>{label}</span>
    </div>
  );

  const barColor =
    storagePercent >= 100
      ? '#ef4444'
      : storagePercent >= 80
      ? '#f59e0b'
      : 'var(--accent-primary)';

  return (
    <aside
      className="app-sidebar desktop-only"
      style={{
        width: '250px',
        borderRight: 'none',
        background: 'transparent',
        paddingRight: '1rem',
        paddingTop: '1.5rem',
      }}
    >
      <div style={{ marginBottom: '1.5rem' }}>
        {TABS.filter((t) => t.section === 'main').map((t) => (
          <NavItem key={t.id} id={t.id} label={t.label} icon={t.icon} />
        ))}
      </div>

      <div
        style={{
          padding: '0 1.5rem',
          fontSize: '0.7rem',
          fontWeight: 700,
          color: 'var(--text-secondary)',
          letterSpacing: '0.05em',
          marginBottom: '0.5rem',
        }}
      >
        LIBRARY
      </div>
      <div style={{ marginBottom: '1.5rem' }}>
        {TABS.filter((t) => t.section === 'library').map((t) => (
          <NavItem key={t.id} id={t.id} label={t.label} icon={t.icon} />
        ))}
      </div>

      <div style={{ marginTop: 'auto', padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontSize: '0.8rem', fontWeight: 600 }}>Storage</span>
            <span
              style={{
                fontSize: '0.75rem',
                fontWeight: 600,
                color: 'var(--accent-primary)',
                background: 'rgba(124, 58, 237, 0.1)',
                padding: '0.1rem 0.4rem',
                borderRadius: '4px',
              }}
            >
              {planName}
            </span>
          </div>
          <div style={{ fontSize: '0.75rem', color: 'var(--text-secondary)' }}>{storageUsedStr}</div>
          <div
            style={{
              width: '100%',
              height: '4px',
              background: 'var(--border-color)',
              borderRadius: '2px',
              overflow: 'hidden',
            }}
          >
            <div
              style={{
                width: `${storagePercent}%`,
                height: '100%',
                background: barColor,
                transition: 'width 0.3s ease, background 0.3s ease',
              }}
            />
          </div>
        </div>

        <button
          className="btn"
          onClick={onUpgradeClick ? onUpgradeClick : () => setActiveTab('settings')}
          style={{
            width: '100%',
            border: '1px solid var(--border-color)',
            background: 'transparent',
            padding: '0.5rem',
            fontSize: '0.8rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            borderRadius: '8px',
            color: 'var(--text-primary)',
            cursor: 'pointer',
          }}
        >
          <span style={{ color: 'var(--accent-primary)' }}>✨</span> Upgrade Plan
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
          <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#10b981' }}></span>
          Server Online <span style={{ marginLeft: 'auto' }}>v1.0.0</span>
        </div>
      </div>
    </aside>
  );
};
